import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openDuplicatesRemoveAllModal = () =>
    openPopupHelper({ popupName: popupNames.DUPLICATES_REMOVE_ALL_MODAL, onClose: closeDuplicatesRemoveAllModal });

const closeDuplicatesRemoveAllModal = () => closePopupHelper(popupNames.DUPLICATES_REMOVE_ALL_MODAL);
